import React from 'react';
import DateTimeContain from '../../../Componant/Forms/FormWidget/DateandTime';

const DateAndTimePicker = () => {
  return (
    <div className='page-body'>
      <DateTimeContain />
    </div>
  );
};
export default DateAndTimePicker;
